import { Button, Col, Progress, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { makeApiRequest } from "../../../shared/api";
import { getCookie, setCookie } from "cookies-next";

const { Title, Text } = Typography;

const KnowledgeAnalysis = ({ setCurrent, kbName, kbDescription }) => {
  const [statusData, setStatusData] = useState(0);
  const [isLoading, setLoading] = useState(false); // Initialize to false, as we aren't immediately loading
  const [kbId, setKbId] = useState(null);
  const textContent = getCookie("fb_text_content");
  const [kbCreationLoading, setKbCreationLoading] = useState(true); // Track KB creation loading

  const FILE_URL = getCookie("fb_file_url");

  useEffect(() => {
    CreateKb();
  }, []);

  useEffect(() => {
    if (statusData === 100) {
      setCurrent(2);
    }
  }, [statusData]);


  useEffect(() => {
    // Only start polling for status after KB is created and we have the kbId
    if (kbId && statusData < 100) {
      const interval = setInterval(() => {
        getKBStatus(kbId);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [kbId, statusData]);

  const getKBStatus = async(kb_id) => {
    try {
      setLoading(true); // Start loading before making the status API request
      const response = await makeApiRequest("GET", `kb/${kb_id}`, {
        kb_id: kb_id, // This is redundant; GET requests typically pass IDs in the URL
      });
      setStatusData(response?.progress);
    } catch (error) {
      console.error("Error fetching status:", error);
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  };

  const CreateKb = async() => {
    setKbCreationLoading(true); // Start KB creation loading
    try {
      const isTextInput = FILE_URL === 'text_input';
      const payload = {
        kb_name: kbName,
        kb_description: kbDescription || null,
        ...(isTextInput 
          ? { kb_content: textContent } 
          : { kb_file_urls: [FILE_URL] }
        )
      };
      const response = await makeApiRequest("POST", "kb", payload);

      if (response && response.kb_id) {
        await setCookie("fb_kb_id", response.kb_id);
        setKbId(response.kb_id);
      } else {
        console.warn(
          "KB created, but kb_id is missing in the response.  Cookie not set."
        );
      }
    } catch (error) {
      console.error("Error creating KB:", error);
    } finally {
      setKbCreationLoading(false); // Stop KB creation loading
    }
  };

  return (
    <div style={{ padding: "40px 20px", textAlign: "center" }}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={14}>
          <Title level={3} style={{ fontWeight: "normal" }}>
            Knowledge Analyzing & Sorting
          </Title>
          <Title level={5} style={{ marginTop: 8 }}>
            Hang tight! We're processing it -{" "}
            <span
              style={{
                backgroundColor: "#ffe58f",
                padding: "2px 6px",
                borderRadius: "4px",
              }}
            >
              Don't close this window.
            </span>
          </Title>
          <Text
            style={{
              display: "block",
              marginTop: 14,
              padding: "0 24px",
              color: "gray",
            }}
          >
            We focus on assessing and structuring information to enhance clarity
            and coherence. This process includes a detailed examination of the
            content, identifying key themes or patterns, and organizing it into
            a logical, accessible format. The goal is to optimize content for
            better understanding and usability.
          </Text>
        </Col>
      </Row>

      <Progress
        percent={statusData}
        status="active"
        size={[600, 30]}
        showInfo
        style={{ marginTop: 50, borderRadius: "4px" }}
        strokeColor={{
          from: "#108ee9",
          to: "#87d068",
        }}
      />

      <div style={{ marginTop: 50 }}>
        <Button
          type="text"
          disabled
          size="large"
        >
          {kbCreationLoading
            ? "Creating Knowledge Base..."
            : isLoading || statusData < 100
              ? "Please wait"
              : "Save & Continue"}
        </Button>
      </div>
    </div>
  );
};

export default KnowledgeAnalysis;
